import { Search } from 'lucide-react'

import { Input } from '@/components/ui/input'

type Props = {
  ref?: React.RefObject<HTMLInputElement | null>
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  value: string
  placeholder?: string
}
export const SearchBox = ({ ref, onChange, value, placeholder = 'Search...' }: Props) => {
  return (
    <div className="relative flex-1">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        ref={ref}
        type="search"
        placeholder={placeholder}
        className="pl-9 w-full"
        onChange={onChange}
        value={value}
      />
    </div>
  )
}
